import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "lightsaber-luke-rotj",
  name: `Lightsaber\nLuke Skywalker Ep6`,
  nameFormatted: {
    primary: "Lightsaber",
    secondary: "Luke Skywalker Ep6",
  },
  origin: "Star Wars: Episode VI - Return of the Jedi",

  category: replicaCategories.starWars,

  versions: [Version1],
};

export default data;
